<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="系统编号">
              <a-input v-model="queryParam.business_no" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                show-search
                allow-clear
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="创建人">
              <a-input v-model="queryParam.create_by" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="approval_needed" slot-scope="text, item">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(item, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <div slot="money_render" slot-scope="text">
        {{ (text / 100).toFixed(4) | numberFormat }}
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleWatchView(record)">预览</a>
          <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'inspection_contract', true)">
            <span>重启审批</span>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)" v-if="!record.is_archived && isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="!record.is_archived && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="!record.is_archived && isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="!record.is_archived && isEdited(record.create_by_id)"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAttachment(record)">附件</a>
              </a-menu-item>
              <a-menu-item v-if="record.version > 1">
                <a @click="handleModifyRecord(record)">查看修改</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleCopy(record)">复制合同</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archivedVisible"
      :visible="archivedVisible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
    <inspection-contract-record :contract="mdl" :visible="recordVisible" @close="recordVisible=false" v-if="recordVisible"/>
    <watch-view-form :model="mdl" :visible="watchViewVisible" @cancel="watchViewVisible=false" v-if="watchViewVisible"/>
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  inspection_contract_list,
  inspection_contract_create,
  inspection_contract_delete,
  inspection_contract_archived,
  inspection_contract_update
} from '@/api/trade_contract'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'
import WatchViewForm from '../modules/WatchViewForm'
import debounce from 'lodash/debounce'
import { client_list } from '@/api/trade_client'
import InspectionContractRecord from '../../project/modules/InspectionContractRecord'
import { project_list } from '@/api/trade_project'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm,
    InspectionContractRecord,
    WatchViewForm
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      clientList: [],
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archivedVisible: false,
      recordVisible: false,
      watchViewVisible: false,
      projectFetching: false,
      projectList: [],
      mdl: {},
      // 查询参数
      queryParam: {
        filter: true
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'business_no',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '合同号',
          dataIndex: 'contract_number',
          width: 150,
          ellipsis: true
        },
        {
          title: '合同名称',
          dataIndex: 'contract_name',
          width: 150,
          ellipsis: true
        },
        {
          title: '计费方式',
          dataIndex: 'billing_method',
          width: 150,
          ellipsis: true
        },
        {
          title: '支付周期',
          dataIndex: 'payment_cycle',
          width: 150,
          ellipsis: true
        },
        {
          title: '支付方式',
          dataIndex: 'payment_method',
          width: 150,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_payment_method[text] || '无'
        },
        {
          title: '商检公司名称',
          dataIndex: 'inspection_company',
          width: 150,
          ellipsis: true
        },
        {
          title: '检验事项',
          dataIndex: 'inspection_items',
          width: 150,
          ellipsis: true
        },
        {
          title: '税率',
          dataIndex: 'tax_rate',
          width: 100,
          ellipsis: true,
          customRender: (text) => text + '%'
        },
        {
          title: '版本',
          dataIndex: 'version',
          width: 100,
          ellipsis: true
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return inspection_contract_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours + minutes }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archivedVisible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archivedVisible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleCopy (record) {
      this.$router.push({ path: '/trade/inspection_contract/' + record.id + '/copy' })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/inspection_contract/' + record.id })
    },
    handleAttachment (record) {
      this.$router.push({ path: '/trade/inspection_contract/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleWatchView (record) {
      this.mdl = record
      this.watchViewVisible = true
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        inspection_contract_update({ is_approval_needed: true }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      } else {
        inspection_contract_update({ is_approval_needed: !record.is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      }
    },
    archived (record) {
      inspection_contract_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      inspection_contract_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleModifyRecord (record) {
      // 查看修改记录
      this.mdl = record
      this.mdl['contract_type'] = 6
      this.recordVisible = true
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          this.confirmLoading = true
          values.attachment = data
          inspection_contract_create(values).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
              this.visible = false
              // 重置表单数据
              form.resetFields()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          inspection_contract_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archivedVisible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleClientSearch (value) {
      client_list({ name: value, project_id: this.$route.params.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    }
  }
}
</script>
